


























































































import { Component, Vue, Mixins, Prop, Watch } from 'vue-property-decorator';
import UserMixin from '@/mixins/UserMixin';
import EditViewMixin from '@/mixins/EditViewMixin';
import DeviceViewMixin from '@/mixins/DeviceViewMixin';
import TopMenu from '@/components/TopMenu.vue';
import FooterMenu from '@/components/FooterMenu.vue';
import SignalStrengthIcon from '@/components/SignalStrengthIcon.vue';

import { Client, WifiStation, IWifiStation, ConnectToWifiStationRequest, DisconnectFromWifiStationRequest } from '@/common/apis/DeviceApi';
import ApiProvider from '@/common/apis/ApiProvider';

import { BModal } from 'bootstrap-vue';

@Component({
    components: {
        TopMenu,
        FooterMenu,
        SignalStrengthIcon,
    },
})
export default class Wifi extends Mixins(DeviceViewMixin, UserMixin) {
    @Prop({required: true})
    public deviceNumber: string;

    public loading: boolean = true;
    public stations: WifiStation[] = [];
    public connecting: boolean = false;

    public joiningStation: IWifiStation | null = null;
    public joiningPassword: string = '';
    public joiningIsConnecting: boolean = false;
    public joiningError: string = '';

    private isMounted: boolean = true;

public mounted() {
        this.updateWiFiList();
        this.isMounted = true;
    }
    public beforeDestroy() {
        this.isMounted = false;
    }

    public async disconnect() {
        const api = ApiProvider.getDeviceApi();
        await api.disconnectFromWifiStation(new DisconnectFromWifiStationRequest({
                deviceId: this.deviceNumber,
        }));
        await this.updateWiFiList();
    }

    public showJoinModal(station: IWifiStation) {
        this.joiningError = '';
        this.joiningStation = station;
        (this.$refs['join-wifi-modal'] as BModal).show();
    }

    public async connectClicked() {
        this.joiningIsConnecting = true;
        if (!this.joiningStation) {
            return;
        }
        try {
            const api = ApiProvider.getDeviceApi();
            await api.connectToWifiStation(new ConnectToWifiStationRequest({
                deviceId: this.deviceNumber,
                wifiStationName: this.joiningStation.name,
                wifiStationPassword: this.joiningPassword,
            }));
            await this.updateWiFiList();
        } catch (e) {
            this.joiningError = e;
        }
        this.joiningIsConnecting = false;
    }

    private async updateWiFiList() {

        this.loading = true;
        try {
            const api = ApiProvider.getDeviceApi();
            const response = await api.getWifiStations(this.deviceNumber);
            if (response.stations) {
                this.stations = response.stations;
            }
            this.loading = false;

        } catch {
            this.loading = false;
        }
        if (this.isMounted) {
            setTimeout(this.updateWiFiList, 15000);
        }
    }
}
